import axios from 'axios'
import pubsub from 'pubsub-js'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Select from 'react-select'
import { Button, Card, CardBody, CardFooter, Col, Input, Row } from 'reactstrap'
import { DeleteDialogBox } from '../../../components/Common/'
import FormValidator from '../../../components/Forms/FormValidator.js'
import ContentWrapper from '../../../components/Layout/ContentWrapper'

const EditTeams = () => {
  const history = useHistory()
  const params = useParams()
  const idTeam = params?.idTeam

  const [isEdit, setIsEdit] = useState(false)
  const [formTeam, setFormTeam] = useState({
    nameTeam: '',
    errors: {}
  })
  const [departments, setDepartments] = useState([])
  const [departmentsSelected, setDepartmentsSelected] = useState([])

  const validateOnChange = (event) => {
    const input = event.target
    const form = input.form
    const value = input.type === 'checkbox' ? input.checked : input.value
    const result = FormValidator.validate(input)

    setFormTeam((prev) => ({
      ...prev,
      [input.name]: value,
      errors: {
        ...prev.errors,
        [input.name]: result
      }
    }))
  }

  const hasError = (formName, inputName, method) => {
    if (formName === 'formTeam') {
      return formTeam.errors && formTeam.errors[inputName] && formTeam.errors[inputName][method]
    }
    return false
  }

  useEffect(() => {
    setIsEdit(!!idTeam)
  }, [idTeam])

  useEffect(() => {
    const getDepartmentId = (dept) => {
      return typeof dept === 'object' && dept._id ? dept._id : dept
    }

    const mapDepartmentToOption = (dept) => ({
      value: dept._id,
      label: dept.name
    })

    const fetchData = async (url) => {
      try {
        const response = await axios.get(url)
        return response.data.success ? response.data : { success: false }
      } catch {
        return { success: false }
      }
    }

    const getAssignedDepartmentIds = (teams) => {
      const assignedIds = new Set()
      const currentTeamIds = new Set()

      teams.forEach((team) => {
        if (!team.departments?.length) return

        team.departments.forEach((dept) => {
          const deptId = getDepartmentId(dept)
          if (idTeam && team._id === idTeam) {
            currentTeamIds.add(deptId)
          } else {
            assignedIds.add(deptId)
          }
        })
      })

      return { assignedIds, currentTeamIds }
    }

    const loadData = async () => {
      try {
        const [teamsResponse, departmentsResponse] = await Promise.all([
          fetchData('teams'),
          fetchData('departments')
        ])

        if (!departmentsResponse.success) return

        const { assignedIds, currentTeamIds } = teamsResponse.success
          ? getAssignedDepartmentIds(teamsResponse.data)
          : { assignedIds: new Set(), currentTeamIds: new Set() }

        const departmentOptions = departmentsResponse.data
          .filter((dept) => !assignedIds.has(dept._id) || currentTeamIds.has(dept._id))
          .map(mapDepartmentToOption)

        setDepartments(departmentOptions)

        if (idTeam) {
          const teamResponse = await fetchData(`teams/${idTeam}`)
          if (teamResponse.success) {
            const teamData = teamResponse.data
            const selectedDepartments = teamData.departments?.map(mapDepartmentToOption) || []

            setFormTeam({
              nameTeam: teamData.name,
              errors: {}
            })
            setDepartmentsSelected(selectedDepartments)
          }
        }
      } catch (error) {
        console.error('Error loading teams/departments:', error)
      }
    }

    loadData()
  }, [idTeam])

  const handleChangeDepartments = (selectedOptions) => {
    setDepartmentsSelected(selectedOptions || [])
  }

  const onSubmit = (e) => {
    e.preventDefault()
    
    const form = e.target
    const inputs = [...form.elements].filter((i) => ['INPUT', 'SELECT'].includes(i.nodeName) && i.name)

    const { errors, hasError: validationError } = FormValidator.bulkValidate(inputs)
    setFormTeam((prev) => ({
      ...prev,
      errors
    }))

    if (!validationError) {
      const postData = {
        name: formTeam.nameTeam,
        departments: departmentsSelected.map((dept) => dept.value)
      }
      if (idTeam) {
        axios
          .put(`teams/${idTeam}`, postData)
          .then((res) => {
            if (res.data.success) {
              history.push('/teams')
              pubsub.publish('showNotification', {
                message: 'Të dhënat janë ndryshuar!',
                type: 'success'
              })
            } else {
              pubsub.publish('showNotification', {
                message: res.data.message || 'Gabim gjatë ndryshimit të të dhënave',
                type: 'error'
              })
            }
          })
          .catch((err) => {
            pubsub.publish('showNotification', {
              message: err.response?.data?.message || 'Gabim gjatë ndryshimit të të dhënave',
              type: 'error'
            })
          })
      } else {
        axios
          .post('teams', postData)
          .then((res) => {
            if (res.data.success) {
              history.push('/teams')
              pubsub.publish('showNotification', {
                message: 'Të dhënat janë ruajtur!',
                type: 'success'
              })
            } else {
              pubsub.publish('showNotification', {
                message: res.data.message || 'Gabim gjatë ruajtjes së të dhënave',
                type: 'error'
              })
            }
          })
          .catch((err) => {
            pubsub.publish('showNotification', {
              message: err.response?.data?.message || 'Gabim gjatë ruajtjes së të dhënave',
              type: 'error'
            })
          })
      }
    }
  }

  const deleteTeam = () => {
    const goBack = () => history.goBack()
    const path = `teams/${idTeam}`
    const name = 'Ekipin'
    DeleteDialogBox({ path, name, goBack })
  }

  return (
    <ContentWrapper>
      {isEdit ? (
        <div className='d-flex justify-content-between'>
          <p style={{ fontSize: 23, color: 'gray' }}>Modifiko Ekipin</p>
          <div>
            <Button onClick={() => history.goBack()} color='info' className='btn-labeled'>
              <span className='btn-label'>
                <i className='fa fa-arrow-left' />
              </span>
              Prapa
            </Button>
          </div>
        </div>
      ) : (
        <div className='d-flex justify-content-between'>
          <p style={{ fontSize: 23, color: 'gray' }}>Shto Ekip</p>
          <div>
            <Button onClick={() => history.goBack()} color='info' className='btn-labeled'>
              <span className='btn-label'>
                <i className='fa fa-arrow-left' />
              </span>{' '}
              Prapa
            </Button>
          </div>
        </div>
      )}
      <Row>
        <div className='col-md-12'>
          <form onSubmit={onSubmit} name='formTeam'>
            {/* START card */}
            <Card className='card-default'>
              <CardBody>
                <legend className='mb-4' />
                <fieldset>
                  <div className='form-group row align-items-center'>
                    <label className='col-md-2 col-form-label'>Emri i Ekipit :</label>
                    <Col md={6}>
                      <Input
                        key='nameTeam'
                        type='text'
                        name='nameTeam'
                        invalid={hasError('formTeam', 'nameTeam', 'required')}
                        onChange={validateOnChange}
                        value={formTeam.nameTeam}
                        data-validate='["required"]'
                      />
                      <span className='invalid-feedback'>Fusha është e nevojshme</span>
                    </Col>
                  </div>
                </fieldset>

                <fieldset>
                  <div className='form-group row align-items-center'>
                    <label className='col-md-2 col-form-label'>Departamentet : (opcionale)</label>
                    <Col md={6}>
                      <Select
                        placeholder='Selekto Departamentet...'
                        name='departmentsSelected'
                        isMulti
                        value={departmentsSelected}
                        options={departments}
                        onChange={handleChangeDepartments}
                        noOptionsMessage={() => 'Nuk ka opsione'}
                      />
                    </Col>
                  </div>
                </fieldset>
              </CardBody>
              {isEdit ? (
                <CardFooter className='text-right'>
                  <button style={{ marginRight: 10 }} type='submit' className='btn btn-info'>
                    Ruaj / Modifiko
                  </button>
                  <Button color='danger' onClick={deleteTeam}>
                    Fshij
                  </Button>
                </CardFooter>
              ) : (
                <CardFooter className='text-right'>
                  <button type='submit' className='btn btn-info'>
                    Ruaj
                  </button>
                </CardFooter>
              )}
            </Card>
            {/* END card */}
          </form>
        </div>
      </Row>
    </ContentWrapper>
  )
}

export default EditTeams
